export default "__VITE_ASSET__8a4c87fa__"